import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import AdminLayout from "layouts/admin";
import DataDeletionPageRider from "views/requestExclude/requestExcludeRider";
import DataDeletionPageDriver from "views/requestExclude/requestExcludeDriver";
import PrivacyPolicyRider from "views/privacyPolicy/privacyPolicyRider";
import PrivacyPolicyDriver from "views/privacyPolicy/privacyPolicyDriver";
import PrivacyPolicySubscriber from "views/privacyPolicy/privacyPolicySubscriber";
import TermsAndConditionsRider from "views/legal/termsAndConditionsRider";
import TermsAndConditionsDriver from "views/legal/termsAndConditionsDriver";
import TermsSubscriber from "views/legal/termsSubscriber";
import CookiePolicy from "views/cookiePolicy/CookiePolicy";
import CookieConsent from "components/CookieConsent";
import { UIService } from "front-lib";

const ProtectedRoute = React.lazy(
  () => import("./views/routes/protectedRoutes")
);
const Login = React.lazy(() => import("./views/login/login"));
const ResetPassword = React.lazy(
  () => import("views/resetPassword/resetPassword")
);
const CustomRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/request-exclude-driver"
        element={<DataDeletionPageDriver />}
      />
      <Route
        path="/request-exclude-rider"
        element={<DataDeletionPageRider />}
      />
      <Route path="/privacy-policy-driver" element={<PrivacyPolicyDriver />} />
      <Route path="/privacy-policy-rider" element={<PrivacyPolicyRider />} />
      <Route path="/privacy-policy-subscriber" element={<PrivacyPolicySubscriber />} />
      <Route path="/terms-driver" element={<TermsAndConditionsDriver />} />
      <Route path="/terms-rider" element={<TermsAndConditionsRider />} />
      <Route path="/terms-subscriber" element={<TermsSubscriber />} />
      <Route path="/cookies-rider" element={<CookiePolicy />} />
      <Route path="/cookies-driver" element={<CookiePolicy />} />
      <Route path="/cookies-subscriber" element={<CookiePolicy />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route element={<ProtectedRoute />}>
        <Route path="admin/*" element={<AdminLayout />} />
      </Route>
    </Routes>
  );
};

const App = () => {
  let persistor = persistStore(store);

  useEffect(() => {
    UIService.eventManager.initialize();
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CustomRoutes />
        <CookieConsent />
      </PersistGate>
    </Provider>
  );
};

export default App;
